/**
 * Boot VID/PID 多型号消歧：弹出型号选择，选中后 claimBootOwner。
 */
import { createApp, type App } from 'vue'
import type { BootAmbiguousPayload, RapooDeviceManager } from '@rapoo/device-sdk'
import i18n from '@/locales'
import BootOwnerPickDialog from '@/components/firmware/BootOwnerPickDialog.vue'

export function promptBootOwnerPick(payload: BootAmbiguousPayload): Promise<string> {
  return new Promise((resolve, reject) => {
    const container = document.createElement('div')
    document.body.appendChild(container)

    let app: App<Element> | null = null
    const cleanup = () => {
      app?.unmount()
      app = null
      container.remove()
    }

    app = createApp(BootOwnerPickDialog, {
      models: payload.models,
      onConfirm: (model: string) => {
        cleanup()
        resolve(model)
      },
      onCancel: () => {
        cleanup()
        reject(new Error('BOOT_OWNER_PICK_CANCELLED'))
      },
    })
    app.use(i18n)
    app.mount(container)
  })
}

/** 绑定 Manager BootAmbiguous → 弹窗 → claimBootOwner */
export function bindBootAmbiguousHandler(manager: RapooDeviceManager): void {
  manager.on('boot:ambiguous', (payload: BootAmbiguousPayload) => {
    void (async () => {
      try {
        const model = await promptBootOwnerPick(payload)
        await manager.claimBootOwner(payload.vendorId, payload.productId, model)
      } catch (error) {
        console.warn('[BootOwnerPick] cancelled or failed', error)
      }
    })()
  })
}
